<template>
  <div class="content">
    <h1 class="has-text-centered">Arduino Due Pins</h1>
    <div class="box">
      <p class="is-size-7-mobile">
          Der Arduino Due ist das erste Arduino-Board, das auf einem 32-Bit-ARM-Kern-Mikrocontroller basiert. Mit 54 digitalen Eingangs-/Ausgangs-Pins, 12 analogen Eingängen, 2 DAC und 2 CAN ist es das perfekte Board für leistungsstarke Arduino-Projekte in größerem Umfang.
      </p>
    </div>
    <div class="box has-text-centered">
      <img src="@/assets/images/pinouts/Pinout-Due.png">
      <p class="is-size-7-mobile">
        Bild von <a target="_blank" href="https://www.arduino.cc/">https://www.arduino.cc/</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pins-arduino-due',
  metaInfo: {
    title: 'Arduino Due Pins | Elektrotechik-Rechner.at',
    meta: [
      {
        name: 'description',
        content: 'Arduino-Board basierend auf Cortex-M3 von ARM mit 54 digitale Eingangs-/Ausgangs-Pins, 12 analogen Eingängen, 2 DAC und 2 CAN.'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: '<span class="fas fa-angle-left"></span> Zurück', route: 'pins' })
  }
}
</script>
